/**
 * Hiring Service
 * Employee application management API calls
 */

import api from '../lib/api';

export const hiringService = {
  // Pipeline Stages
  async getPipelineStages() {
    const response = await api.get('/hiring/pipeline-stages');
    return response.data;
  },

  // Applications
  async getApplications(params = {}) {
    const response = await api.get('/hiring/employee-applications', { params });
    return response.data;
  },

  async getApplicationsByStage(stage) {
    const response = await api.get('/hiring/employee-applications', { params: { stage } });
    return response.data;
  },

  async getApplicationById(id) {
    const response = await api.get(`/hiring/employee-applications/${id}`);
    return response.data;
  },

  async createApplication(data) {
    const response = await api.post('/hiring/employee-applications', data);
    return response.data;
  },

  async updateApplication(id, data) {
    const response = await api.put(`/hiring/employee-applications/${id}`, data);
    return response.data;
  },

  async deleteApplication(id, reason) {
    const params = reason ? { reason } : {};
    const response = await api.delete(`/hiring/employee-applications/${id}`, { params });
    return response.data;
  },

  // Application Stages
  async updateStage(id, stage) {
    const response = await api.put(`/hiring/employee-applications/${id}/stage`, { stage });
    return response.data;
  },

  async updateApplicationStage(id, stage, reason) {
    const data = { stage };
    if (reason) data.reason = reason;
    const response = await api.put(`/hiring/employee-applications/${id}/stage`, data);
    return response.data;
  },

  // Application Activities
  async getActivities(applicationId) {
    const response = await api.get(`/hiring/employee-applications/${applicationId}/activities`);
    return response.data;
  },

  async getApplicationActivities(applicationId) {
    return this.getActivities(applicationId);
  },

  async addActivity(applicationId, data) {
    const response = await api.post(`/hiring/employee-applications/${applicationId}/activities`, data);
    return response.data;
  },

  // Convert to Employee
  async convertToEmployee(applicationId, data) {
    const response = await api.post(`/hiring/employee-applications/${applicationId}/convert`, data);
    return response.data;
  },

  async convertToUser(applicationId, data) {
    return this.convertToEmployee(applicationId, data);
  },

  // Recruiters
  async getRecruiters() {
    const response = await api.get('/users', { params: { role: 'admin', status: 'active' } });
    return response.data;
  },
};
